<adapt-strategy-board-agenda-item *adaptIfAuthorised="EditStrategicInputs; else featureNotEnabled"
                                  [pageActivationTours]="pageActivationTours"
                                  buttonText="Attach inputs to strategic working board"></adapt-strategy-board-agenda-item>
<ng-template #featureNotEnabled>
    <span>This feature is enabled only for the Scale+ platform subscription.</span>
</ng-template>
